import { render, staticRenderFns } from "./NewCourseStep1.vue?vue&type=template&id=43885732"
import script from "./NewCourseStep1.vue?vue&type=script&lang=js"
export * from "./NewCourseStep1.vue?vue&type=script&lang=js"
import style0 from "./NewCourseStep1.vue?vue&type=style&index=0&id=43885732&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports